import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "/logo-gv.png";

export default function PublicHeader() {
  const location = useLocation();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 glass-card"
      style={{ borderRadius: 0, borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: "1px solid var(--mm-border)" }}
      data-testid="public-header"
    >
      <div className="container flex items-center justify-between h-16 sm:h-20 gap-3">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0" data-testid="public-logo-link">
          <img src={LOGO_URL} alt="GoldVision Logo" className="w-10 h-10 sm:w-12 sm:h-12 object-contain" />
          <span className="text-base sm:text-xl font-bold hidden md:block gold-text whitespace-nowrap" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            GOLDVISION
          </span>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-6">
          <Link
            to="/diventa-studente"
            className="text-xs sm:text-sm font-bold transition-colors duration-200"
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              letterSpacing: "0.06em",
              color: location.pathname === "/diventa-studente" ? "var(--mm-gold)" : "var(--mm-text-secondary)"
            }}
            data-testid="public-nav-diventa-studente"
          >
            DIVENTA STUDENTE
          </Link>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/login"
            className="px-4 sm:px-6 py-2 rounded-lg text-xs sm:text-sm font-bold transition-all duration-200 hover:scale-[1.03] whitespace-nowrap"
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "0.05em", background: "linear-gradient(135deg, #2FD8A8 0%, #1FB489 100%)", color: "#0A0A0A" }}
            data-testid="public-login-btn"
          >
            ACCEDI
          </Link>
        </div>
      </div>
    </header>
  );
}
